<template>
  <MDBFooter :text="['white', 'lg-start']" bg="">
    <MDBContainer class="pt-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div class="mb-4 mb-md-0">
          <ul class="mb-0 lh-lg">
            <li><a href="https://webinarweek.net/contact/">お問い合わせ</a></li>
            <li><a href="https://webinarweek.net/pdf/privacy.pdf">個人情報取得の許諾について</a></li>
            <li><a href="https://and-on.net/about">Andonについて</a></li>
            <li><a href="https://webinarweek.net/exhibitor/">参加企業用ログイン</a></li>
            <li><a href="https://webinarweek.net/top/">Webinar Week総合TOPページ</a></li>
          </ul>
        </div>
        <div class="mb-4 mb-md-0">
          <div>
            <router-link to="/" class="img-link mb-3"><img src="@/assets/ロゴ横型.png" alt="DXWWロゴ"></router-link>
          </div>
          <div>
            <p>
              <u>事業主体</u><br>
              株式会社松井製作所(Andon Webinar Week事業部)<br>
              <u>協賛</u><br>
              一般社団法人日本AM協会<a class="text-white ms-1" target="_blank"  href="https://jsam.or.jp/"> https://jsam.or.jp/</a><br>
              グリーン・モールディング・ソリューション協会<a class="text-white ms-1" target="_blank"  href="https://greenmolding.org/japanese/"> https://greenmolding.org/japanese/</a><br>
              <u>運営委託先</u><br>
              株式会社まなれぼ<a class="text-white ms-1" target="_blank"  href="https://manarevo.com/"> https://manarevo.com/</a><br>
            </p>
          </div>
        </div>
      </div>
    </MDBContainer>
    <div class="text-center p-3" style="font-size: 0.7rem"> &#169; 2023 Andon Webinar Week</div>
  </MDBFooter>


  <div class="fixed-action-btn" id="top_view_btn">
    <router-link  class="btn btn-lg" :to="{hash: '#anchor_top'}">▲</router-link>
  </div>
</template>

<script>
import {
  MDBFooter,
  MDBContainer,
} from 'mdb-vue-ui-kit';

export default {
  components: {
    MDBFooter,
    MDBContainer,
  },
};
</script>

<style lang="scss">
footer {
  margin-top: auto;
  background:  var(--primary-05);
  .container {
    a:not(.img-link) {
      color: #ffffff;
      text-decoration: none;
      position: relative;
      transition: .3s;

      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        width: 0;
        height: 1px;
        transition: .3s;
        background-color: #fff;
      }

      &:hover::after {
        width: 100%;
      }
    }
  }

  img {
    max-width: 350px;
  }
}

#top_view_btn {
  right: 0.2rem;
  bottom: 1rem;
  padding: 0;

  a {
    color: var(--primary);
    border: 1px solid var(--primary);
    padding: 10px;
    line-height: 1.8rem;
    background-color: rgb(255 255 255/40%);
    transition: 0.7s;
  }
}
</style>